export default __webpack_public_path__ + "static/media/p2023-3.84e56448.jpeg";